import React, { useState, useEffect } from "react";
import { Redirect, Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { QuickStart } from "../quickstart/quickstart-ctrl";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import {PrepareHomeView} from './home-view';
import serviceProvider from '../../services/axios'

export const PrepareHomeCtrl=(props)=>{
    const [results, setResults] = useState([]);
    const [defaultData,setDefaultData]=useState([]);
    const [filterPlants, setFilterPlants] = useState("");
    const [isquickstart, setisquickStart] = useState(false);
    const user = JSON.parse(localStorage.getItem("userData"));
	const login = localStorage.getItem("isLoggedIn");
	
      const usid = user ? user.uid : 0;
    useEffect(() => {
          props.handleExpandFal();
          const search = async () => {
              const apiUrl = `/home?param=homedata&filterPlants=${filterPlants}&uid=${usid}`;
              const { data } = await serviceProvider.get(apiUrl,true,{});
              setDefaultData(data);
              setResults(data);
          };
          search();
      }, [filterPlants]);
        useEffect(() => {
		
		if(props.location.pathname.split('/')[1]=="quickstartopen")
		{
			setisquickStart(true);
		}
		}, []);
		    if (!login) {
		        return <Redirect to="/sign-in" />;
	        }

            if (results.length) {
                return(
                    <>
                        <Helmet>
                            <link rel="stylesheet" href={require('./home.scss').require} />
                        </Helmet>
                        <BreadcrumbsItem to="/">Home</BreadcrumbsItem>
                    
                            <PrepareHomeView homeData={results} defaultData={defaultData} onFilter={setFilterPlants}  {...props} />
                    <QuickStart  isquickstart = {isquickstart} {...props} />
                    </>
                )
            }{
                            return (
                            <>
                                <div></div>
                            </>
                        );
                }
}